import { Button } from "@mui/material";
import { EditOutlined as EditIcon } from "@mui/icons-material";
import PropTypes from "prop-types";
import colorsFoundation from "../tokens/colors-foundation.js";

export default function EditButton({
  onClick,
  children = "Bearbeiten",
  disabled = false,
}) {
  return (
    <Button
      color="inherit"
      size="small"
      variant="outlined"
      onClick={onClick}
      disabled={disabled}
      endIcon={
        <EditIcon
          sx={{
            color: colorsFoundation.neutral[700],
            fontSize: "1.2rem !important",
          }}
        />
      }
      sx={{
        borderColor: "divider",
        color: "text.secondary",
        fontSize: 14,
        padding: "4px 12px",
        "&:hover": { backgroundColor: "action.hover" },
        fontWeight: 400,
      }}
    >
      {children}
    </Button>
  );
}

EditButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node,
};
